import { createSelector } from '@reduxjs/toolkit'

import { selectMarketYoyGrowthExpectationState } from './selectMarketYoyGrowthExpectationState'

export const selectMarketYoyGrowthExpectationPlanning = createSelector(
  [selectMarketYoyGrowthExpectationState],
  (state) => state.planning
)
